export const getLocalAudioToURL = (path: string) => {
  return import('@tauri-apps/api/path').then(({ resolveResource }) => resolveResource(path).then((result) => {
    return import('@tauri-apps/plugin-fs').then(({ readFile }) => readFile(result).then((value) => {
      const blob  = new Blob([value as BlobPart])
      const url = URL.createObjectURL(blob)
      return url
    }).catch((err) => {
      throw new Error(err)
    }))
  }))
}
